'use client'

import { Builder } from '@builder.io/react'

import { CartPageContentDefaults } from '@src/components/CartPageContent/CartPageContent.defaults'

import { CartPageContent } from './CartPageContent'

Builder.registerComponent(CartPageContent, {
  name: 'CartPageContent',
  inputs: [
    {
      name: 'copy',
      friendlyName: 'Copy texts',
      type: 'object',
      defaultValue: CartPageContentDefaults.copy,
      subFields: [
        {
          name: 'continue',
          friendlyName: 'Button copy',
          type: 'text',
          defaultValue: CartPageContentDefaults.copy.continue,
        },
        {
          name: 'orderSummary',
          friendlyName: 'Order Summary heading',
          type: 'text',
          defaultValue: CartPageContentDefaults.copy.orderSummary,
        },
        {
          name: 'subtotal',
          type: 'text',
          defaultValue: CartPageContentDefaults.copy.subtotal,
        },
        {
          name: 'subtotalDisclaimer',
          type: 'text',
          defaultValue: CartPageContentDefaults.copy.subtotalDisclaimer,
        },
        {
          name: 'yourCart',
          friendlyName: 'Your Cart heading',
          type: 'text',
          defaultValue: CartPageContentDefaults.copy.yourCart,
        },
        {
          name: 'emptyCart',
          friendlyName: 'Empty cart heading',
          type: 'text',
          defaultValue: CartPageContentDefaults.copy.emptyCart,
        },
        {
          name: 'continueShopping',
          friendlyName: 'Empty cart CTA copy',
          type: 'text',
          defaultValue: CartPageContentDefaults.copy.continueShopping,
        },
      ],
    },
    {
      name: 'emptyCartCtaLink',
      friendlyName: 'Empty cart link',
      type: 'text',
      defaultValue: CartPageContentDefaults.emptyCartCtaLink,
    },
    {
      name: 'continueLink',
      friendlyName: 'Continue Link',
      type: 'text',
      defaultValue: '/checkout',
    },
  ],
})
